export default __webpack_public_path__ + "static/media/Youtube.7d3ae5af.svg";